// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   GetItemByGrp,
//   GetItemGroup,
//   PostSalesOrder,
// } from "../../../APIServices/SalesService/OrderService/OrderThunk";
// import toast, { Toaster } from "react-hot-toast";
// import { HashLoader } from "react-spinners";
// import ItemGroupDiv from "./Itemgroup";
// import SearchBar from "../SalesShared/SearchBar/SearchBar";
// import "./OrderPage.css";
// import Itempage from "./ItemPage";
// import { BiArrowBack } from "react-icons/bi";
// import {
//   getImagePath,
//   mapDeliveryType,
//   validateSalesInteger,
// } from "../../../SharedFiles/Helper/utils";
// import { BsCart4 } from "react-icons/bs";
// import { FaChevronRight } from "react-icons/fa6";
// import CheckOut from "./CheckOut";
// import {
//   showDeleteConfirmation,
//   showSubmitConfirmation,
// } from "../../../SharedFiles/WarningMessage/deleteWarning";
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
// } from "@mui/material";
// import { IoMdArrowRoundBack } from "react-icons/io";
// import { debounce } from "lodash";
// import { decryptUserInfo } from "../../../SharedFiles/decryption/Decryption";

// const Order = () => {
//   const dispatch = useDispatch();
//   const userData = sessionStorage.getItem('user');
//   const parsedUserData = userData ? JSON.parse(userData) : null;
//     const decryptedUserInfo = parsedUserData && decryptUserInfo(parsedUserData);
//     const userId    = decryptedUserInfo && decryptedUserInfo[0].USERID    ;
//     const category = decryptedUserInfo && decryptedUserInfo[0].CATEGORY;
//   // const [itemGrpData, setItemGrpData] = useState(null);
//   const [cartItems, setCartItems] = useState([]);
//   const [itemGroupFlag, setItemGroupFlag] = useState(
//     sessionStorage.getItem("itemGroupFlag") === "true" ? "true" : "false"
//   );
//   const [isCheckout, setIsCheckout] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [quantity, setQuantity] = useState("");
//   const [quantityNos, setQuantityNos] = useState("");
//   const [customerData, setCustomerData] = useState("");
//   const [showItemData, setShowItemData] = useState(false);
//   const [remarks, setRemarks] = useState("");
//   const [showAddress, setshowAddress] = useState("");
//   const [yesLoading, setisLoading] = useState(false);
//   const [selectedRadio, setSelectedRadio] = useState("");
//   const [type, setType] = useState("bundle");
//   const [contactNumber, setContactNumber] = useState("");
//   const [customernameView, setCustomernameView] = useState("");
//   const [customerAddressView, setCustomerAddressView] = useState("");
//   const [InProgress, setInProgress] = useState({
//     FetchItemGroup: false,
//     FetchItem: false,
//     fetchCustomer: false,
//     PostSales: false,
//     FetchSearchItem: false,
//   });
//   const { ItemGroup, ItemByGrp, PostSoOrder, CustomerData, error, loading } =
//     useSelector((state) => state.order);
//   const isLoading = () => {
//     return (
//       loading.ItemGroup ||
//       loading.ItemByGrp ||
//       loading.PostSoOrder ||
//       loading.ItemBySearch
//     );
//   };

//   useEffect(() => {
//     const storedCartItems = sessionStorage.getItem("cartItems");
//     if (storedCartItems) {
//       setCartItems(JSON.parse(storedCartItems)); // Set cart items from sessionStorage if available
//     }
//   }, []);

//   useEffect(() => {
//     const fetchItemGroup = debounce(() => {
//       if (!ItemGroup && !InProgress.FetchItemGroup) {
//         setInProgress((prev) => ({ ...prev, FetchItemGroup: true }));
//         dispatch(GetItemGroup());
//       }
//     }, 300); // Debounce time (in ms)

//     fetchItemGroup();
//   }, [ItemGroup, dispatch]);

//   const Checker = () => {
//     if (InProgress.FetchItemGroup) {
//       if (error.ItemGroupError) {
//         toast.error("Error occur while Fetch Item Group");
//       }

//       setInProgress({ ...InProgress, FetchItemGroup: false });
//     }

//     if (InProgress.FetchItem) {
//       if (error.ItemGroupError) {
//         toast.error("Error occur while Fetch Item Group");
//         setInProgress({ ...InProgress, FetchItem: false });
//       }
//       if (ItemByGrp && !loading.ItemByGrp) {
//         setItemGroupFlag("true");
//         sessionStorage.setItem("itemGroupFlag", "true");
//         setInProgress({ ...InProgress, FetchItem: false });
//       }
//     }

//     if (InProgress.PostSales) {
//       if (error.PostSoOrderError) {
//         const errorss = error.PostSoOrderError;
//         const status = errorss.errorCode;
//         if (status) {
//           toast.error(errorss.errorMessage);
//         } else {
//           toast.error("Error occur while Posting a Data");
//         }
//         setInProgress({ ...InProgress, PostSales: false });
//       }
//       if (PostSoOrder === "Success") {
//         toast.success("Order Placed Successful");
//         sessionStorage.removeItem("cartItems");
//         sessionStorage.removeItem("itemGroup");
//         sessionStorage.removeItem("itemGroupFlag");
//         setIsCheckout(false);
//         setRemarks("");
//         setSelectedRadio("");
//         setType('');
//         setCustomerData("");
//         setCustomernameView("");
//         setshowAddress("");
//         setCustomerAddressView("");
//         setContactNumber('');
//         setItemGroupFlag(null);
//         setCartItems([]);
//         setInProgress({ ...InProgress, PostSales: false });
//       }
//     }
//   };

//   useEffect(() => {
//     Checker();
//   }, [ItemGroup, PostSoOrder, loading, error]);

//   const handleBackItemGrp = () => {
//     if (!showItemData) {
//       sessionStorage.removeItem("itemGroupFlag");
//       sessionStorage.removeItem("itemGroup");
//       setItemGroupFlag("");
//     } else {
//       setShowItemData(false);
//     }
//   };

//   const handlePlaceOrder = () => {
//     if (!isCheckout) {
//       setIsCheckout(true);
//     }
//   };

//   const handleConfirmOrder = () => {
//     if (!customerData.card_Code) {
//       toast.error("Customer Code is required to confirm the order.");
//       return;
//     }

//     showSubmitConfirmation(() => {
//       const dataList = {
//         customerCode: customerData.card_Code,
//         DeliveryDate: "07/04/2025",
//         BranchId: 1,
//         Remarks: remarks,
//         itemDetails: cartItems.map((item) => ({
//           ItemCode: item.item_Code,
//           Quantity:type === 'bundle' ?item.quantityNos: item.quantity,
//           noinbundle: type === 'bundle' ?item.quantity: item.quantityNos,
//           WareHouseCode: "FG",
//           ShipAddress: selectedRadio,
//           priority: item.priority ? "Y" : "N",
//         })),
//         SplCode:category ==='S1'? userId: -1,
//       };
//       setInProgress({ ...InProgress, PostSales: true });
//       // setisLoading(true);
//  dispatch(PostSalesOrder(dataList));
//     });
//   };

//   const removeFromCart = (itemCode) => {
//     showDeleteConfirmation(() => {
//       // Filter out the item with the matching itemCode
//       const updatedCartItems = cartItems.filter(
//         (item) => item.item_Code !== itemCode
//       );

//       // Update the cart state
//       setCartItems(updatedCartItems);

//       // Save the updated cartItems array to sessionStorage
//       sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems,...type));
//     });
//   };
//   const handleType = (selectvalue) => {
//     setQuantity("");
//     setQuantityNos('');
//     setType(selectvalue);
//   };
// const handleQtyChange = (value) => {
//   const noinbundleValue = parseInt(selectedItem.noinbundle, 10) || 0;
//   if (value===''||validateSalesInteger(value)) {
//   if (type === 'bundle') {
//       const numericValue = parseInt(value, 10) || 0;
//       const result = parseInt(value * noinbundleValue);
//       setQuantity(value);
//       setQuantityNos(result);
//   } else {
//     // Allow decimals for other types

//     const numericValue = parseFloat(value) || 0;
//     const result = noinbundleValue !== 0 ? (numericValue / noinbundleValue).toFixed(2) : "0.00";
//     setQuantity(value);
//     setQuantityNos(result);
//   }
// }

// };

//   const addToCart = (item) => {
//     if (quantity <= 0) {
//       alert("Quantity must be greater than 0."); // You can replace this with a more user-friendly error message
//       return; // Prevent adding to the cart if quantity is invalid
//     }
//     const existingItemIndex = cartItems.findIndex(
//       (cartItem) => cartItem.item_Code === selectedItem.item_Code
//     );
//     let updatedCartItems;

//     if (existingItemIndex !== -1) {
//       // If item already exists, update the quantity
//       updatedCartItems = [...cartItems];
//       updatedCartItems[existingItemIndex].quantity = quantity;
//       updatedCartItems[existingItemIndex].quantityNos = quantityNos;
//     } else {
//       // If item doesn't exist, add it as a new item
//       updatedCartItems = [
//         ...cartItems,
//         {
//           ...selectedItem,
//           quantity: quantity,
//           quantityNos: quantityNos,
//         },
//       ];
//     }
//     // Update the cart state
//     setCartItems(updatedCartItems);
//     // Save the updated cartItems array in sessionStorage
//     sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
//     setShowModal(false);
//   };

// const openModal = (item) => {
//   setSelectedItem(item);
//   setShowModal(true);
//   const existingItemIndex = cartItems?.findIndex(
//     (cartItem) => cartItem.item_Code === item.item_Code
//   );
//   if (existingItemIndex !== -1) {
//     const qty = cartItems[existingItemIndex];
//     const noinbundleValue = parseInt(qty.quantityNos, 10) || 0;
//   //   const result = qty.quantity * noinbundleValue;
//     setQuantityNos(qty.quantityNos);
//     setQuantity(qty.quantity);
//   } else {
//     setQuantity("");
//     setQuantityNos("");
//   }
// };

//   const closeModal = () => {
//     setShowModal(false);
//     setSelectedItem(null);
//     setQuantity("");
//     setQuantityNos("");
//   };

//   return (
//     <div>
//       {isCheckout ? (
//         <CheckOut
//           setCartItems={setCartItems}
//           cartItems={cartItems}
//           setIsCheckout={setIsCheckout}
//           removeFromCart={removeFromCart}
//           openModal={openModal}
//           InProgress={InProgress}
//           setInProgress={setInProgress}
//           customerData={customerData}
//           setCustomerData={setCustomerData}
//           setRemarks={setRemarks}
//           setshowAddress={setshowAddress}
//           showAddress={showAddress}
//           remarks={remarks}
//           setSelectedRadio={setSelectedRadio}
//           selectedRadio={selectedRadio}
//           setCustomernameView={setCustomernameView}
//           customernameView={customernameView}
//           setCustomerAddressView={setCustomerAddressView}
//           customerAddressView={customerAddressView}
//           setContactNumber={setContactNumber}
//           contactNumber={contactNumber}

//         /> // Show Checkout if isCheckout is true
//       ) : (
//         <>
//           <div className="SearchContiner position-relative">
//             {itemGroupFlag === "true" && !showItemData ? (
//               <button className="SalesBackButton">
//                 {/* <BiArrowBack onClick={handleBackItemGrp} size={24} /> */}
//                 <IoMdArrowRoundBack
//                   className="backicon"
//                   onClick={handleBackItemGrp}
//                 />

//                 {/* <i className="pi pi-delete-left backicon" onClick={handleBackItemGrp}></i> */}
//               </button>
//             ) : (
//               <></>
//             )}
//             <SearchBar
//               showItemData={showItemData}
//               setShowItemData={setShowItemData}
//               itemGroupFlag={itemGroupFlag}
//               InProgress={InProgress}
//               setInProgress={setInProgress}
//               cartItems={cartItems}
//               openModal={openModal}
//               removeFromCart={removeFromCart}
//             />
//           </div>
//           {!showItemData && (
//             <>
//               {itemGroupFlag === "true" ? (
//                 <Itempage
//                   cartItems={cartItems}
//                   openModal={openModal}
//                   removeFromCart={removeFromCart}
//                 />
//               ) : (
//                 <ItemGroupDiv
//                   setInProgress={setInProgress}
//                   InProgress={InProgress}
//                 /> // Otherwise, render ItemGroupDiv
//               )}
//             </>
//           )}
//         </>
//       )}
//       {cartItems.length > 0 && !isCheckout && (
//         <div className="palceOrder-Bottom">
//           <div className="cart-quantity">
//             <div>
//               <BsCart4 className="" fontSize={21} />
//             </div>
//             <div>
//               <p className="item">{cartItems.length} Product</p>
//             </div>
//           </div>
//           <div className="placeorderbtn">
//             <button onClick={handlePlaceOrder}>
//               Place Order{" "}
//               <span>
//                 <FaChevronRight size={16} className="RightIcon" color="white" />
//               </span>
//             </button>
//           </div>
//         </div>
//       )}
//       {cartItems.length > 0 && isCheckout && (
//         <div className="palceOrder-Bottom checkout-bottom">
//           <div className="cart-quantity checkout-quantity">
//             <BsCart4 className="" fontSize={24} />
//             {cartItems.length} Product
//           </div>
//           <div className="placeorderbtn checkoutbtn">
//             <button onClick={handleConfirmOrder}>Confirm Order</button>
//           </div>
//         </div>
//       )}
//       {showModal && selectedItem && (
//         <Dialog open={showModal}>
//           <DialogTitle className="Modal-heading">Product Quantity</DialogTitle>
//           <DialogContent className="salesDialog">
//             <div>
//               <div className="lineDiv lineDivItem">
//                 <span className="image-div">
//                   <img
//                     src={getImagePath(selectedItem.deliverY_TYPE)}
//                     alt={selectedItem.deliverY_TYPE}
//                     className="group-image"
//                   />
//                 </span>
//                 <li className="groupSize align-items-center">
//                   <div className="itmlist">
//                     <p className="itemcode item">{selectedItem.item_Name}</p>
//                     <span className="itemname item">
//                       {selectedItem.height.toFixed(2)} mm
//                     </span>
//                     <p className="itemcode item">{selectedItem.item_Code}</p>
//                   </div>
//                 </li>
//               </div>
//               <div className="quantityDiv">
//                 <p className="item quantityHeader">Enter Required Quantity</p>
//                 <p className="item noinbundle">
//                   ({selectedItem.noinbundle} bars per Bundle)
//                 </p>
//                 <div className="quantityinput">
//                   <div>
//                     <p className="item">
//                       <select
//                         onChange={(e) => handleType(e.target.value)}
//                         value={type}>
//                         <option value="bundle">Bundle</option>
//                         <option value="quantity">Quantity</option>
//                       </select>
//                  </p>
//                   </div>
//                   <input
//                     type="text"
//                     placeholder={
//                       type === "bundle" ? "Enter Bundle" : "Enter Quantity"
//                     }
//                     onChange={(e) => handleQtyChange(e.target.value)}
//                     value={quantity}
//                   />
//                 </div>
//                 <p className="item noinbundle">
//                   {type === "bundle"
//                     ? `No of bars: ${quantityNos || 0}`
//                     : `No of bundles: ${quantityNos || 0}`}
//                 </p>
//               </div>
//             </div>
//           </DialogContent>
//           <DialogActions className="custom-dialog-actions">
//             <Button className="Modal-cancel" onClick={closeModal}>
//               Cancel
//             </Button>
//             <Button
//               className="Modal-submit"
//               onClick={addToCart}
//               // disabled={isSubmitDisabled}
//             >
//               Add to Cart
//             </Button>
//           </DialogActions>
//         </Dialog>
//       )}
//       {isLoading() && (
//         <div className="loader-sales">
//           <HashLoader color="#ed1c24" />
//         </div>
//       )}
//       <Toaster
//         position="top-center"
//         toastOptions={{
//           style: {
//             fontSize: "16px",
//             padding: "16px",
//             width: "400px",
//             borderRadius: "8px",
//           },
//         }}
//       />
//     </div>
//   );
// };

// export default Order;

import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  GetItemByGrp,
  GetItemGroup,
  PostSalesOrder,
  PotingSaleData,
} from "../../../APIServices/SalesService/OrderService/OrderThunk";
import toast, { Toaster } from "react-hot-toast";
import { HashLoader } from "react-spinners";
import ItemGroupDiv from "./Itemgroup";
import SearchBar from "../SalesShared/SearchBar/SearchBar";
import "./OrderPage.css";
import Itempage from "./ItemPage";
import CheckOut from "./CheckOut";
import { IoMdArrowRoundBack } from "react-icons/io";
import { debounce } from "lodash";
import useOrderLogic from "./UserOrderFunction";
import QuantityModal from "./quantityModel";
import PlaceButton from "./PlaceQutotaionButton";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { resetPostOrderStatus } from "../../../APIServices/SalesService/OrderService/OrderAction";
import { decryptUserInfo } from "../../../SharedFiles/decryption/Decryption";

const Order = () => {
  const orderLogic = useOrderLogic();
  const {
    cartItems,
    setCartItems, handleConfirmOrder,
    customerForm, setCustomerForm,
    handlePlaceOrder,
    showModal,
    openModal,
    closeModal,
    selectedItem,
    quantity,
    quantityNos,
    editing,
    type,
    showItemData,
    setShowItemData,
    setType,
    isCheckout,
    setIsCheckout,
    handleQtyChange,
    setQuantityNos,
    setQuantity,
    addToCart,
    setOrderType,OrderType,
    InProgress,setAttachments,attachments,
    setInProgress, customerData, setCustomerData,
    removeFromCart,
  } = orderLogic;
  const dispatch = useDispatch();
  const [itemGroupFlag, setItemGroupFlag] = useState(
    sessionStorage.getItem("itemGroupFlag") === "true" ? "true" : "false"
  );
  const [showOrderTypeModal, setShowOrderTypeModal] = useState(false);
  const userData = sessionStorage.getItem('user');
  const parsedUserData = userData ? JSON.parse(userData) : null;
  const decryptedUserInfo = parsedUserData && decryptUserInfo(parsedUserData);
  const { ItemGroup, PostSalesQ, UpdateSalesQ, ItemByGrp, 
    PostSoOrder, CustomerData, error, loading } = useSelector((state) => state.order);
  const isLoading = () => {
    return (
      loading.ItemGroup ||
      loading.ItemByGrp ||
      loading.PostSoOrder ||
      loading.ItemBySearch ||
      loading.PostSalesQ
    );
  };

  useEffect(() => {
    const storedCartItems = sessionStorage.getItem("cartItems");
    if (storedCartItems) {
      setCartItems(JSON.parse(storedCartItems)); // Set cart items from sessionStorage if available
    }
  }, []);

  useEffect(() => {
    const fetchItemGroup = debounce(() => {
      if (!ItemGroup && !InProgress.FetchItemGroup) {
        setInProgress((prev) => ({ ...prev, FetchItemGroup: true }));
        dispatch(GetItemGroup());
      }
    }, 300); // Debounce time (in ms)

    fetchItemGroup();
  }, [ItemGroup, dispatch]);

  const Checker = () => {
    if (InProgress.FetchItemGroup) {
      if (error.ItemGroupError) {
        toast.error("Error occur while Fetch Item Group");
      }
      setInProgress({ ...InProgress, FetchItemGroup: false });
    }

    if (InProgress.FetchItem) {
      if (error.ItemGroupError) {
        toast.error("Error occur while Fetch Item Group");
        setInProgress({ ...InProgress, FetchItem: false });
      }
      if (ItemByGrp && !loading.ItemByGrp) {
        setItemGroupFlag("true");
        sessionStorage.setItem("itemGroupFlag", "true");
        setInProgress({ ...InProgress, FetchItem: false });
      }
    }
    // if (InProgress.PostSales) {
    //   if (error.PostSoOrderError) {
    //     const errorss = error.PostSoOrderError;
    //     const status = errorss.errorCode;
    //     if (status) {
    //       toast.error(errorss.errorMessage);
    //     } else {
    //       toast.error("Error occur while Posting a Data");
    //     }
    //     setInProgress({ ...InProgress, PostSales: false });
    //   }
    //   if(PostSoOrder === "Success"){
        
    //     toast.success("Order Placed Successful");
    //     setInProgress({ ...InProgress, PostSales: false });
    //     clearData();
    //      }
    // }
    if (InProgress.PostSQ) {
      if (error.PostSaleSQError || error.PostSoOrderError) {
        const errorss = error.PostSaleSQError || error.PostSoOrderError;
        const status = errorss.errorCode;
        if (status) {
          toast.error(errorss.errorMessage);
        } else {
          toast.error("Error occur while Posting a Data");
        }
        dispatch(resetPostOrderStatus({ key: 'PostSaleSQError', type: 'error' }));
        setInProgress({ ...InProgress, PostSQ: false });
      }
      if (PostSalesQ === "Success") {
        let message = "";
        if(OrderType === "quotation"){
            message = "Quotation Placed Successful";
        } else if (OrderType === "order") {
          message = "Order Placed Successful";
        }
        toast.success(message);
        setInProgress({ ...InProgress, PostSQ: false });
        clearData();
    }

      // if (PostSalesQ === "Success" || PostSoOrder === "Successs") {
      //   if (PostSalesQ === "Success") {
      //     toast.success("Quotation Placed Successful");
      //   }else if (PostSoOrder === "Success") {
      //     toast.success("Order Placed Successful");
      //   }
      //   sessionStorage.removeItem("cartItems");
      //   sessionStorage.removeItem("itemGroup");
      //   sessionStorage.removeItem("itemGroupFlag");
      //   setIsCheckout(false);
      //   setType("");
      //   setCustomerForm({
      //     customerName: "",
      //     address: "",
      //     contactNumber: "",
      //     remarks: "",
      //     customerCode: "",
      //     addressShort: ""
      //   });
      //   setCustomerData("");
      //   setItemGroupFlag(null);
      //   setCartItems([]);
      //   dispatch(resetPostOrderStatus()); 
      //   setInProgress({ ...InProgress, PostSQ: false });
      // }
    }
  };
  const clearData=()=>{
    sessionStorage.removeItem("cartItems");
    sessionStorage.removeItem("itemGroup");
    sessionStorage.removeItem("itemGroupFlag");
    setIsCheckout(false);
    setType("");
    setCustomerForm({
      customerName: "",
      address: "",
      contactNumber: "",
      remarks: "",
      customerCode: "",
      addressShort: ""
    });
    setAttachments([]);
    setCustomerData("");
    setItemGroupFlag(null);
    setCartItems([]);
    // dispatch(resetPostOrderStatus()); 
    dispatch(resetPostOrderStatus({ key: 'PostSalesQ', type: 'data' }));
  }

  useEffect(() => {
    Checker();
  }, [ItemGroup, PostSoOrder, PostSalesQ, UpdateSalesQ, loading, error]);

  const handleBackItemGrp = () => {
    if (!showItemData) {
      sessionStorage.removeItem("itemGroupFlag");
      sessionStorage.removeItem("itemGroup");
      setItemGroupFlag("");
    } else {
      setShowItemData(false);
    }
  };


  const handleType = (selectvalue) => {
    setQuantity("");
    setQuantityNos("");
    setType(selectvalue);
  };

  const onConfirmOrderClick = () => {
    if (!editing && !customerData.card_Code) {
      toast.error("Customer Code is required to confirm the order.");
      return;
    }
    const userId = Number(decryptedUserInfo[0]?.USERID); // Ensure numeric comparison

    if (userId === 6 || userId === 7) {
      setShowOrderTypeModal(true);
    } else {
      setShowOrderTypeModal(false); // Optional: If needed for other logic
      handleConfirmOrder("quotation");
    }
  }
  return (
    <div>
      {isCheckout ? (
        <CheckOut
          setCartItems={setCartItems}
          cartItems={cartItems}
          type={type}
          setIsCheckout={setIsCheckout}
          removeFromCart={removeFromCart}
          openModal={openModal}
          isCheckout={isCheckout}
          InProgress={InProgress}
          setInProgress={setInProgress}
          customerData={customerData}
          setCustomerData={setCustomerData}
          customerForm={customerForm}
          setCustomerForm={setCustomerForm}
          showItemData={showItemData}
          setShowItemData={setShowItemData}
          itemGroupFlag={itemGroupFlag}
          editing={editing}
          setAttachments={setAttachments}
          attachments={attachments}
        /> // Show Checkout if isCheckout is true
      ) : (
        <>
          <div className="SearchContiner position-relative">
            {itemGroupFlag === "true" && !showItemData ? (
              <button className="SalesBackButton">
                {/* <BiArrowBack onClick={handleBackItemGrp} size={24} /> */}
                <IoMdArrowRoundBack
                  className="backicon"
                  onClick={handleBackItemGrp}
                />

                {/* <i className="pi pi-delete-left backicon" onClick={handleBackItemGrp}></i> */}
              </button>
            ) : (
              <></>
            )}

            <SearchBar
              showItemData={showItemData}
              setShowItemData={setShowItemData}
              itemGroupFlag={itemGroupFlag}
              InProgress={InProgress}
              setInProgress={setInProgress}
              cartItems={cartItems}
              openModal={openModal}
              removeFromCart={removeFromCart}
            />
          </div>
          {!showItemData && (
            <>
              {itemGroupFlag === "true" ? (
                <Itempage
                  cartItems={cartItems}
                  openModal={openModal}
                  removeFromCart={removeFromCart}
                  editing={editing}
                />
              ) : (
                <ItemGroupDiv
                  setInProgress={setInProgress}
                  InProgress={InProgress}
                /> // Otherwise, render ItemGroupDiv
              )}
            </>
          )}
        </>
      )}
      <PlaceButton
        handlePlaceOrder={handlePlaceOrder}
        isCheckout={isCheckout}
        cartItems={cartItems}
        handleConfirmOrder={onConfirmOrderClick}
        editing={editing}
      />

      {showModal && selectedItem && (
        <QuantityModal
          showModal={showModal}
          handleQtyChange={handleQtyChange}
          closeModal={closeModal}
          handleType={handleType}
          type={type}
          selectedItem={selectedItem}
          quantityNos={quantityNos}
          quantity={quantity}
          addToCart={addToCart}
          setCartItems={setCartItems}
          cartItems={cartItems}
        />
      )}
      {isLoading() && (
        <div className="loader-sales">
          <HashLoader color="#ed1c24" />
        </div>
      )}
      <Dialog open={showOrderTypeModal} onClose={() => setShowOrderTypeModal(false)}>
        <DialogTitle>Select Order Type</DialogTitle>
        <DialogActions>
          <Button onClick={() => {
            setShowOrderTypeModal(false);
            handleConfirmOrder("quotation");
          }}
            color="primary">
            Sales Quotation
          </Button>
          <Button onClick={() => {
            setShowOrderTypeModal(false);
            handleConfirmOrder("order");
          }}
            color="secondary">
            Sales Order
          </Button>
        </DialogActions>
      </Dialog>

      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </div>
  );
};

export default Order;
